import { setZone } from '@src/crossFrame/apis/ToolMenu'
import _ from 'lodash'

let zoneInfo = {
    zoneName: 'Unknown',
    subzoneName: 'Unknown',
    zone: undefined,
    subzone: undefined,
    currentZoneDisplay: 'Unknown',
}

const zoneInfoChangeCallbacks = []

let t: any

/**
 * This needs to be enabled before initializing Notiifcation Task Service.
 * Uncomment Commented section from App/index.tsx to Initialize Zone Service.
 * Uncomment zoneSlice code.
 * ZoneService might not be required and implemented in different way.
 * Currently migrating as in Seaward.
 */
export const initLocalization = (translate: any) => {
    t = translate
    zoneInfo.zoneName = zoneInfo.zoneName === 'Unknown' ? t('migrated-ihm-seaward-unknown-label') : zoneInfo.zoneName
    zoneInfo.subzoneName = zoneInfo.subzoneName === 'Unknown' ? t('migrated-ihm-seaward-unknown-label') : zoneInfo.subzoneName
    zoneInfo.currentZoneDisplay = zoneInfo.currentZoneDisplay === 'Unknown' ? t('migrated-ihm-seaward-unknown-label') : zoneInfo.currentZoneDisplay
}

export const addZoneInfoChangeCallback = (callback: (value: any) => void) => {
    zoneInfoChangeCallbacks.push(callback)
}

export const setZoneInfo = (zone, subzone) => {
    const currentZoneDisplayString = localized() ?
        zone.zoneDisplayName + ' ' + subzone.subzoneDisplayName + ' ' + t('migrated-ihm-seaward-zone-label') :
        zone.zoneDisplayName + ' ' + subzone.subzoneDisplayName + ' zone'

    zoneInfo = {
        zoneName: zone.zoneName,
        subzoneName: subzone.subzoneName,
        zone,
        subzone,
        currentZoneDisplay: currentZoneDisplayString,
    }

    zoneInfoChangeCallbacks.forEach((callback) => {
        callback(zoneInfo)
    })

    setZone(zoneInfo)
}

export const getZoneInfo = () => {
    return _.cloneDeep(zoneInfo)
}

export const getCurrentZoneDisplay = () => {
    return zoneInfo.currentZoneDisplay
}

export const getZone = () => {
    return zoneInfo.zone
}

export const getSubZone = () => {
    return zoneInfo.subzone
}

const localized = () => {
    return t !== undefined
}
